/**
 * Открытие внешних ссылок из Mini App.
 *
 * window.open внутри Telegram ведёт себя по-разному на разных клиентах:
 * где-то открывает встроенный браузер поверх приложения, где-то ничего не
 * делает. SDK передаёт ссылку клиенту, и тот открывает её как положено:
 * t.me — внутри Telegram, остальное — во внешнем браузере.
 */
import { openLink, openTelegramLink, shareURL } from '@telegram-apps/sdk-react';

export function openExternal(href: string): void {
  // Telegram открывает только абсолютные адреса, а документы лежат
  // на нашем же домене и задаются путём.
  const url = new URL(href, window.location.href).href;
  const isTelegram = /^https:\/\/t\.me\//i.test(url);

  if (isTelegram && openTelegramLink.isAvailable()) {
    openTelegramLink(url);
    return;
  }
  if (!isTelegram && openLink.isAvailable()) {
    openLink(url);
    return;
  }
  // Вне Telegram (разработка в браузере) SDK недоступен.
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * Поделиться ссылкой через выбор чата Telegram.
 *
 * Внутри Telegram это родной список чатов — человек отправляет ссылку
 * другу в два нажатия. Вне его (разработка) — системное меню «Поделиться»,
 * а где нет и его, возвращаем false, чтобы вызывающий скопировал ссылку.
 */
export async function shareLink(url: string, text: string): Promise<boolean> {
  if (shareURL.isAvailable()) {
    shareURL(url, text);
    return true;
  }
  if (navigator.share) {
    try {
      await navigator.share({ url, text });
      return true;
    } catch {
      return false;
    }
  }
  return false;
}
